import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/university/marketplace/')({

}).lazy(() => import('./index.lazy').then((d) => d.Route));
